module.exports = __webpack_public_path__ + "h5/img/floor2.e9d847db.png";